module.exports = __webpack_public_path__ + "static/media/gucci.053c2d90.png";